<template>
  <div class="plage">
    <div class="row">
      <div class="col-6 col-sm-12 z-10">
        <div class="padd padd--bigger">
          <title-comp>
            <h1 class="blue">
              BIENVENUE <br>
              <span>à LA PLAGE</span>
            </h1>
          </title-comp>
          
          <div class="rel mobile cover-mobile">
            <img src="/images/la-plage-cover-mobile.jpg" v-in-viewport.once class="transition rs" /> 
            <scroll-button /> 
          </div>
          
          <p v-in-viewport.once class="transition">
            Le Grand Théâtre ouvre ses portes et en profite pour sortir faire un tour. Se balader, rencontrer ses voisins, prendre un café en terrasse ou refaire le monde. Nous vous surprendrons avec des activités inédites et insolites au Grand Théâtre, au coin d’une rue ou assis au parc. 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
            <br class="desktop"> 
          </p>

        </div>
      </div>

      <div class="col-6 col-sm-12">
        <div class="desktop">
          <div class="imagewrapper pb-125">
            <parallax>
              <img src="/images/la-plage-cover.jpg" class="rs" />
            </parallax>
          </div>
          <scroll-button />
        </div>
        <parallax factor="50"><div class="textdeco textdeco--left textdeco--blue">local</div></parallax>
      </div>
    </div>

    <div class="row">
      <div class="col-6 col-sm-12">
        <div class="imagewrapper pb-125">
          <parallax>
            <img src="/images/la-plage-c-est-ou.jpg" v-in-viewport.once class="rs transition" />
          </parallax>
        </div>
      </div>
      <div class="col-6 col-sm-12 rel">
        <div class="padd">
          <div class="shadowbg shadowbg--tl shadowbg--tl-blue"></div>
          <title-comp>
            <h2 class="blue">
              C’EST QUOI<br> 
              <span>LA PLAGE ?</span>
            </h2>
          </title-comp>
          <p v-in-viewport.once class="transition">
            <b>Late Nights</b> ou l’art de rentrer à l’opéra et de ne plus rentrer chez soi ; <b>Duels</b> ou l’art de se disputer sur scène pour de vrai, un format qui interroge le monde contemporain avec des questions (im)pertinentes ; <b>Apéropéra</b> ou tout ce que vous avez toujours voulu savoir sur Wagner et que vous n’avez jamais osé demander à Verdi ; <b>Voilà voilà</b> ou comment poser des questions bêtes et pas bêtes après le spectacle aux artistes ; <b>Le Grand Brunch</b> pour débriefer la semaine tout en dorures ; <b>En coulisse</b> pour les curieux d’entre vous ; ou encore les <b>Intropéras</b> avant chaque spectacle. Tout sera fait pour vous accompagner lors de nouvelle saison.
          </p>
          <div class="shadowbg shadowbg--br-blue"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6 col-sm-12">
        <div class="padd--vert padd--mobile">
          <title-comp>
            <h2 class="blue size-90">
              C’EST OÙ<br> 
              <span>LA PLAGE ?</span>
            </h2>
          </title-comp>
          
          <p v-in-viewport.once class="transition">
            Derrière un écran en plein air ou dans la salle de votre quartier, avec votre musée préféré ou dans votre école, on retrouvera La Plage un peu partout, selon l’humeur, quelquefois à l’intérieur du Grand Théâtre, quelquefois extra-muros, quelquefois un mode urbain et mondain, quelquefois un mode existentiel et interrogateur, toujours sous les pavés&nbsp;!
          </p>
        </div>
      </div>
      <div class="col-2"></div>
    </div>

    <carrousel class="carrousel--left carrousel--reconstruire marg--bottom">
      <div class="carrousel__item carrousel__item--reconstruire">
        <div class="imagewrapper pb-65">
          <img src="/images/la-plage-slider1.jpg" class="rs">
        </div>
      </div>
      <div class="carrousel__item carrousel__item--reconstruire">
        <div class="imagewrapper pb-65">
          <img src="/images/la-plage-slider2.jpg" class="rs">
        </div>
      </div>
    </carrousel>

    <twitter-feed />
    <push-footer />

  </div>
</template>

<style lang="scss">
.plage{
  
}
</style>

<script>
import Vue from 'vue'

import Page from '../pages/Page.vue'

import ButtonArrow from '../components/ButtonArrow.vue';
import PushFooter from '../components/PushFooter.vue';
import TwitterFeed from '../components/TwitterFeed.vue';
import ScrollButton from '../components/ScrollButton.vue';
import Carrousel from '../components/Carrousel.vue';
import TitleComp from '../components/TitleComp.vue';
import Parallax from '../components/Parallax.vue';

let LaPlage = Vue.extend({
  mixins: [Page],
  components: {
    ButtonArrow, TwitterFeed, PushFooter, ScrollButton, Carrousel, TitleComp, Parallax
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted(){

  }
});

export default LaPlage
</script>
